import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomerQuote from "../../components/QuoteBuilder/CustomerQuote";
import PackageTermQuote from "../../components/QuoteBuilder/PackageTermQuote";
import VehiclesQuote from "../../components/QuoteBuilder/VehiclesQuote";
import DriversQuote from "../../components/QuoteBuilder/DriversQuote";
import AdditionalProtectionQuote from "../../components/QuoteBuilder/AdditionalProtectionQuote";
import PricingQuote from "../../components/QuoteBuilder/PricingQuote";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import _ from "lodash";
import { Link, useHistory } from "react-router-dom";

const Customer = (props) => {
	const { makeModels, municipalities, trackData } = props;
	const [showModal, setShowModal] = useState(false);
	const [drivers, setDrivers] = useState([]);
	const [cars, setCars] = useState([]);
	const [amount, setAmount] = useState([]);
	const [loading, setLoading] = useState(true);
	const [copyUrlState, setCopyUrlState] = useState(false);
	let history = useHistory();

	const [url, setUrl] = useState("");

	const renewalData = useSelector((state) => state.RenewalData);
	const renewalId = useSelector((state) => state.RenewalId);

	useEffect(() => {
		if (renewalData) {
			setDrivers(renewalData.drivers);
			setCars(renewalData.cars);
			setAmount(renewalData.amount);
			setLoading(false);
		}
	}, [renewalData]);

	const handleClose = () => {
		setShowModal(false);
	};

	const seeAllQuotes = () => {
		history.push(`/admin/quote-builder/list-quotes`);
	};

	const copyUrl = () => {
		navigator.clipboard.writeText(url);
		setCopyUrlState(true);
		setTimeout(() => {
			setCopyUrlState(false);
		}, 2000);
	};

	const handleShowModal = () => {
		const headers = new Headers({
			"X-CSRF-Token": getMeta("csrf-token"),
			"X-Requested-With": XMLHttpRequest,
			Accept: "application/json",
		});
		fetch(`/api/v2/quotes/${renewalId}/quote_link`, { method: "GET", headers })
			.then((response) => response.json())
			.then((data) => {
				setUrl(data.quote_url);
				setShowModal(true);
			});
	};

	function getMeta(metaName) {
		const metas = document.getElementsByTagName("meta");

		for (let i = 0; i < metas.length; i++) {
			if (metas[i].getAttribute("name") === metaName) {
				return metas[i].getAttribute("content");
			}
		}

		return "";
	}

	return (
		<>
			{loading ? (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						paddingTop: "24px",
					}}
				>
					<Spinner
						animation="border"
						style={{ height: "4rem", width: "4rem" }}
					/>
				</div>
			) : (
				<React.Fragment>
					<div className="customer general d-flex justify-content-center">
						<div className="otcontainer1 nopadding col otmb-4">
							<div className="col">
								<h1 className="otmt-2 otmb-4" style={{ color: "#00778a" }}>
									Quote Builder
								</h1>
							</div>
							<CustomerQuote
								cars={cars}
								drivers={drivers}
								makeModels={makeModels}
							/>
							<PackageTermQuote
								renewalData={renewalData}
								renewalId={renewalId}
								trackData={trackData}
							/>
							<hr className="softline l1 mt-2 otmt-2" />
							<VehiclesQuote
								cars={cars}
								makeModels={makeModels}
								renewalId={renewalId}
								renewalData={renewalData}
							/>
							<hr className="softline l1 mt-2 otmt-2" />
							<DriversQuote
								drivers={drivers}
								renewalId={renewalId}
								renewalData={renewalData}
								municipalities={municipalities}
							/>
							<hr className="softline l1 mt-2 otmt-2" />
							<AdditionalProtectionQuote
								renewalId={renewalId}
								renewalData={renewalData}
							/>
							<hr className="softline l1 mt-2 otmt-2" />
							<PricingQuote
								amount={amount}
								renewalId={renewalId}
								renewalData={renewalData}
							/>
							<hr className="softline l1 mt-2 otmt-2" />
							<div className="d-md-flex justify-content-center otmt-2">
								{/* <div className="col-12 col-md-4 pr-md-2">
									<button className="btn btn1 btn-lg btn-block text-uppercase">
										preview quote
									</button>
								</div> */}
								<div className="col-12 col-md-4 pl-md-2">
									<button
										className="btn btn2 btn-lg btn-block text-uppercase"
										onClick={() => handleShowModal()}
									>
										generate quote
									</button>
								</div>
							</div>
						</div>
					</div>

					<Modal
						className="cars-modal mx-auto general customer"
						show={showModal}
						onHide={handleClose}
						centered
						size="lg"
					>
						<div className="col-11 mx-auto otmt-3">
							<div className="justify-content-md-center mx-auto">
								<div className="col-12 mt-4">
									<h1 style={{ color: "#00788A" }}>Share quote</h1>
								</div>
								<div className="heading">
									<div className="desc"></div>
								</div>
							</div>
							<div className="bodymodal has-outline otmt-1">
								<div className="d-flex flex-column">
									<div className="otml-3 otmt-2 otmb-1">
										<p>
											Your quote has been created. Copy the URL to share the
											quote.
										</p>
									</div>

									<div
										style={{ border: "1px solid #979797" }}
										className="otml-3 otmr-3 otmb-4"
									>
										<div className="otmb-2 otmt-1 d-sm-flex justify-content-around">
											<u
												type="button"
												style={{ color: "#01788A" }}
												className="mt-3 ml-md-5"
											>
												{url}
											</u>
											<div className="col d-flex justify-content-center mt-2">
												{!copyUrlState ? (
													<i
														class="bi bi-clipboard"
														style={{ fontSize: "15px", cursor: "pointer" }}
														onClick={() => copyUrl()}
													></i>
												) : (
													<i
														class="bi bi-check"
														style={{ fontSize: "15px", cursor: "pointer" }}
														onClick={() => copyUrl()}
													></i>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
							<Modal.Footer className="d-flex justify-content-center">
								<div className="col-12 d-md-flex justify-content-center mt-4 otmb-4">
									<div className="">
										<button
											onClick={handleClose}
											className="btn btn-italic btn-lg btn-outline-light btn-fixed-width col-12"
										>
											<span className="font-weight-bolder mb-2 mt-2 p">
												CANCEL
											</span>
										</button>
									</div>
									<div className="ml-md-5 mt-4 mt-md-0">
										<button
											className="btn btn-danger btn-italic btn-lg btn-fixed-width col-12"
											onClick={seeAllQuotes}
										>
											{/* <span
												className="font-weight-bolder mb-2 mt-2 p"
												onClick={() => {
													navigator.clipboard.writeText(url);
												}}
											>
												COPY URL
											</span> */}
											<span className="font-weight-bolder mb-2 mt-2 p">
												SEE ALL QUOTES
											</span>
										</button>
									</div>
								</div>
							</Modal.Footer>
						</div>
					</Modal>
				</React.Fragment>
			)}
		</>
	);
};
export default Customer;
